__turbopack_context__.v({
  "invalid": "BaseTextArea-module__gsezfG__invalid",
  "root": "BaseTextArea-module__gsezfG__root",
});
